import { useMemo } from 'react'
import { Typography, Flex, Tag } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { sampleQuestions, categoryStyles, pickRandomQuestions } from './aiAssistantModel'

type Props = {
  onSendMessage: (text: string) => void
  disabled: boolean
}

const ChatWelcome = ({ onSendMessage, disabled }: Props) => {
  const questions = useMemo(() => pickRandomQuestions(sampleQuestions, 3), [])

  return (
    <Flex vertical align="center" gap={16} style={{ maxWidth: 600, width: '100%' }}>
      <Tag color="orange" style={{ fontSize: 13, padding: '2px 12px' }}>Early Preview</Tag>
      <Typography.Title level={4} style={{ margin: 0 }}>
        How can I help?
      </Typography.Title>
      <Typography.Text type="secondary" style={{ textAlign: 'center', maxWidth: 440 }}>
        {"I'm an early preview. You can currently ask about labor hours. More data like invoices, jobs, sales, and customers is on the way."}
      </Typography.Text>
      <Typography.Text type="secondary" style={{ fontSize: 11, letterSpacing: 1.5, textTransform: 'uppercase' as const, marginTop: 8 }}>
        Suggested Questions
      </Typography.Text>
      <Flex vertical gap={8} style={{ width: '100%' }}>
        {questions.map(({ question, category }) => {
          const style = categoryStyles[category]
          return (
            <div
              key={question}
              onClick={() => !disabled && onSendMessage(question)}
              style={{
                padding: '12px 16px',
                borderRadius: 8,
                border: '1px solid #f0f0f0',
                background: '#fafafa',
                cursor: disabled ? 'default' : 'pointer',
                opacity: disabled ? 0.5 : 1,
                display: 'flex',
                alignItems: 'center',
                gap: 12,
                transition: 'all 0.2s',
              }}
              onMouseEnter={(e) => {
                if (!disabled) {
                  e.currentTarget.style.borderColor = '#f47458'
                }
              }}
              onMouseLeave={(e) => {
                if (!disabled) {
                  e.currentTarget.style.borderColor = '#f0f0f0'
                }
              }}
            >
              <div style={{
                width: 32,
                height: 32,
                minWidth: 32,
                borderRadius: 8,
                background: style.background,
                border: `1px solid ${style.border}`,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}>
                <FontAwesomeIcon icon={style.icon} style={{ color: style.color, fontSize: 14 }} />
              </div>
              <div>
                <div style={{ fontSize: 14, fontWeight: 500, color: '#262626' }}>{question}</div>
                <div style={{ fontSize: 12, color: '#8c8c8c', marginTop: 2 }}>{category}</div>
              </div>
            </div>
          )
        })}
      </Flex>
    </Flex>
  )
}

export default ChatWelcome
